$(document).ready(function(){
  
  // Random Number Starts
  function randomIntFromInterval(min, max) { // min and max included 
    return Math.floor(Math.random() * (max - min + 1) + min)
  }  
  const rndInt = randomIntFromInterval(5, 10);
  //document.getElementsByClassName("actualPerson")[0].firstChild.nodeValue = rndInt;
   $(".actualPerson").text(rndInt);
  
  // Random Number Ends  
});


// Lars Timer Code Starts

document.addEventListener("DOMContentLoaded", function() {
  function updateDeliveryDate() {
    let now = new Date();
    let currentHour = now.getHours();
    let deliveryDay;
    let daysToAdd;
    let nextDeadlineHour;
    
    
    
    // Finden Sie die nächste Deadline basierend auf der aktuellen Uhrzeit
    if (currentHour < 10) {
      nextDeadlineHour = 10;
    } else if (currentHour < 14) {
      nextDeadlineHour = 14;
    } else if (currentHour < 18) {
      nextDeadlineHour = 18;
    } else if (currentHour < 22) {
      nextDeadlineHour = 22;
    } else {
      nextDeadlineHour = 10; // am nächsten Tag
    }
    
    
    
    switch (now.getDay()) {
      // Montag bis Donnerstag
      case 1:
      case 2:
      case 3:
      case 4:
      if (currentHour < 10) {
        daysToAdd = 1;
      } else {
        daysToAdd = 2;
      }
      break;
      
      
      
      // Freitag
      case 5:
      if (currentHour < 10) {
        daysToAdd = 1;
      } else {
        daysToAdd = 3;
      }
      break;
      
      
      
      // Samstag
      case 6:
      if (currentHour < 10) {
        daysToAdd = 2;
      } else {
        daysToAdd = 3;
      }
      break;
      // Sonntag
      case 0:
        daysToAdd = 2;
      break;
      
      default:
      daysToAdd = 2;
    }
    
    let deliveryDate = new Date();
    deliveryDate.setDate(now.getDate() + daysToAdd);
    let weekdays = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
    deliveryDay = weekdays[deliveryDate.getDay()];
    
    // Update Countdown bis zur nächsten Deadline
    let hoursUntilDeadline = nextDeadlineHour - currentHour - 1; // -1, weil wir die volle Stunde nicht mitzählen
    let minutesUntilDeadline = 59 - now.getMinutes();
    let secondsUntilDeadline = 59 - now.getSeconds();
    
    document.getElementById('time').innerText = String(hoursUntilDeadline).padStart(2, '0') + ':' + String(minutesUntilDeadline).padStart(2, '0') + ':' + String(secondsUntilDeadline).padStart(2, '0');
    $('.dataArea p i').text(deliveryDay);
    // document.getElementById('delivery-day').innerText = deliveryDay;
  }
  
  setInterval(updateDeliveryDate, 1000);
});

// Lars Timer Code Ends




// CountDown Timer Starts - Dev Team
  // var getValue = $("strong#time").text();
  // //console.log("Time =>", getValue);  
  // var start = new Date;
  // var newStart = new Date;
  // //start.setHours(getValue, 0, 0); // 12am Because #time has text = 12
  

  // var numberOfDaysToAdd;
  // var currentHour = start.getHours();

  // if(currentHour >= 0 && currentHour <= 10){
  //   numberOfDaysToAdd = 1 ;
  //   newStart.setHours(10, 0, 0);
  //   console.log("Current Hour =>", currentHour);
  //   // console.log("Number of Days to Add =>", numberOfDaysToAdd);
  //   // console.log("Set Hours => 10");
  //   // console.log("Get Time =>", newStart);
  // }else if(currentHour > 10 && currentHour <= 14){
  //   numberOfDaysToAdd = 2 ;
  //   newStart.setHours(14, 0, 0);
  //    console.log("Current Hour =>", currentHour);
  //   // console.log("Number of Days to Add =>", numberOfDaysToAdd);    
  //   // console.log("Set Hours => 14");
  //   // console.log("Get Time =>", newStart);
  // }else if(currentHour > 14 && currentHour <= 18){
  //   numberOfDaysToAdd = 2 ;
  //   newStart.setHours(18, 0, 0);
  //    console.log("Current Hour =>", currentHour);
  //   // console.log("Number of Days to Add =>", numberOfDaysToAdd);    
  //   // console.log("Set Hours => 18");
  //   // console.log("Get Time =>", newStart);
  // }else if(currentHour > 18 && currentHour <= 23){
  //   numberOfDaysToAdd = 2 ;
  //   newStart.setHours(22, 0, 0);
  //    console.log("Current Hour =>", currentHour);
  //   // console.log("Number of Days to Add =>", numberOfDaysToAdd);  
  //   // console.log("Set Hours => 22");
  //   // console.log("Get Time =>", newStart);
  // }

  // const weekday = ["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"];
  // let day = weekday[start.getDay()];
  // console.log("Today =>", day);

  
  // var result = start.setDate(start.getDate() + numberOfDaysToAdd);  
  // var newResult = new Date(result);
  // let newDay = weekday[newResult.getDay()];

  
  
  // if(newDay == 'Samstag'){
  //   var saturdayResult = start.setDate(start.getDate() + 3);  
  //   var newwwResult = new Date(saturdayResult);
  //   var newwwDay = weekday[newwwResult.getDay()];
  //   console.log("If Saturday In German =>", newwwDay);
  //   $('.dataArea p i').text('Nächsten ' + newwwDay);
  // }else if(newDay == 'Sonntag'){
  //   var saturdayResult1 = start.setDate(start.getDate() + 2); 
  //   var newwwResult1 = new Date(saturdayResult1);
  //   var newwwDay1 = weekday[newwwResult1.getDay()];
  //   console.log("If Sunday In German =>", newwwDay1);
  //   $('.dataArea p i').text('Nächsten ' +newwwDay1);
  // }else{
  //   console.log("After " + numberOfDaysToAdd + " Days =>", newDay);
  //   $('.dataArea p i').text(newDay);
  // }
  
  

  // showTimer();
  
  // function pad(num) {
  //   return ("0" + parseInt(num)).substr(-2);
  // }

  // function showTimer() {
  //   var now = new Date;
  //   if (now > newStart) { // too late, go to tomorrow
  //     newStart.setDate(newStart.getDate() + 1);
  //   }
  //    // console.log("Now =>", now);
  //    // console.log("Start =>", newStart);
  //   var remain = ((newStart - now) / 1000);
  //   // console.log("Remaining =>", remain);
  //   var hh = pad((remain / 60 / 60) % 60);
  //   var mm = pad((remain / 60) % 60);
  //   var ss = pad(remain % 60);
  //   document.getElementById('time').innerHTML =
  //     hh + ":" + mm + ":" + ss;
  //   setTimeout(showTimer, 1000);
  // }
// CountDown Timer Ends - Dev Team